import u from 'umbrellajs';
import {
	checkElement2
	// addCSSFileToDOM
} from './domUtils';

const unsplashBox = `unsplash-box-right`;
const inputSearch = `input-unsplash-search-right`;
const submitSearch = `submit-unsplash-search-right`;
const unsplashBoxSelector = `#${unsplashBox}`;
const inputSearchSelector = `#${inputSearch}`;
const submitSearchSelector = `#${submitSearch}`;

export const getCSSToTemplateReport = (templateName, mode) => {
	const cssList = [];
	if (mode === 'editor') {
		cssList.push(`/css/website_templates/bulma-customise.css`);
	}
	cssList.push(`/css/report_templates/${templateName}.css`);

	cssList.push(`/css/editor.css`);
	return cssList;
};

export const getCSSToEbookIntro = templateName => {
	const cssList = [];
	// if (mode === 'editor') {
	// 	cssList.push(`/css/website_templates/bulma-customise.css`);
	// }
	cssList.push(`/css/ebook_intro_templates/${templateName}.css`);

	cssList.push(`/css/editor.css`);
	return cssList;
};

// const addCSSToTemplateReport = (templateName, mode) => {
// 	const docHead = window.grapesjs.Canvas.getDocument().head;
// 	if (mode === 'editor') {
// 		addCSSFileToDOM(`/css/website_templates/bulma-customise.css`, docHead);
// 	}
// 	addCSSFileToDOM(`/css/report_templates/${templateName}.css`, docHead);
//
// 	addCSSFileToDOM(`/css/editor.css`, docHead);
// };

export const getCSSToTemplateWebsite = templateName => {
	const cssList = [];
	let bulmaCssName = 'bulma-customise.css';
	if (['template9', 'template10'].includes(templateName)) {
		bulmaCssName = 'bulma-customise-navbar.css';
	}
	// bulma css
	cssList.push({ href: `/css/website_templates/${bulmaCssName}` });
	cssList.push({
		href: `https://static.goalsmapper.com/public/personal_website/pretty-checkbox.min.css`
	});
	cssList.push({
		href: `https://static.goalsmapper.com/public/personal_website/all.min.css`
	});
	// templates.css
	cssList.push({ href: `/css/website_templates/${templateName}/template.css` });
	cssList.push({ href: `/css/editor.css` });
	return cssList;
};

// const addCSSToTemplateWebsite = templateName => {
// 	const docHead = window.grapesjs.Canvas.getDocument().head;
// 	let bulmaCssName = 'bulma-customise.css';
// 	if (['template9', 'template10'].includes(templateName)) {
// 		bulmaCssName = 'bulma-customise-navbar.css';
// 	}
// 	// bulma css
// 	addCSSFileToDOM(`/css/website_templates/${bulmaCssName}`, docHead);
// 	console.log('added');
// 	// templates.css
// 	addCSSFileToDOM(`/css/website_templates/${templateName}/template.css`, docHead);
// 	addCSSFileToDOM(`/css/editor.css`, docHead);
// 	console.log('docHead', docHead);
// };

// const addCSSToTemplate = (templateName, mode) => {
// 	// if (window.reportMode) {
// 	// 	addCSSToTemplateReport(templateName, mode);
// 	// } else {
// 	// 	addCSSToTemplateWebsite(templateName, mode);
// 	// }
// };

const cleanUpSearchResults = () => {
	// should clean up images
	const allElements = u('#unsplash-box-right .gjs-am-asset');
	allElements.remove();

	const paginationElement = u('.unsplash-right-pagination');
	paginationElement.remove();
};

const onImageClick = event => {
	const style = event.target.getAttribute('style');
	// background-image: url('https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080&fit=max&ixid=eyJhcHBfaWQiOjY4NzE1fQ');
	const imageUrl = style.substring(style.indexOf('(') + 2, style.indexOf(')') - 1);
	// console.log('onImageClick', imageUrl);
	const selectedComponent = window.grapesjs.getSelected();
	if (selectedComponent && selectedComponent.is('image')) {
		selectedComponent.set('src', imageUrl);
	} else {
		// should set background cover to this image
		const dc = window.grapesjs.DomComponents;
		const allComponents = dc.getComponents();
		// console.log('allComponents allComponents', allComponents.at(2));
		const coverImageComponent = allComponents
			.at(2)
			.components()
			.at(0);
		// console.log('allComponents coverImageComponent', coverImageComponent);
		if (coverImageComponent) {
			coverImageComponent.set('src', imageUrl);
		}

		// allComponents.forEach(component => {
		//   const collection = component.components();
		//   // if (collection.length > 0) {
		//   console.log(component.getView(), collection.length);
		//   collection.forEach(insideComp => {
		//     console.log('insideComp', insideComp.getView());
		//   });
		//   // }
		// });
	}
};

const addEventListenerImageClick = () => {
	// add click event listener
	const allElements = u('#unsplash-box-right .gjs-am-asset-image');
	allElements.handle('click', onImageClick);
};

const generatePagination = (data, searchPage = 1) => {
	let { total_pages } = data;
	// Limit to 40 pages results now
	total_pages = Math.min(total_pages, 40);
	// console.log('TCL: generatePagination total_pages', total_pages);
	if (!total_pages) {
		return;
	}
	// <a href="#">&laquo;</a>
	// <a href="#">&raquo;</a>

	let innerA = '';
	for (let i = 1; i <= total_pages; i += 1) {
		if (i === parseInt(searchPage, 10)) {
			innerA += `
                <a href="#" class="active" data-search-page=${i}>${i}</a>
                `;
		} else {
			innerA += `
                <a href="#">${i}</a>
                `;
		}
	}
	const innerHTML = `
        <div class="unsplash-right-pagination pagination">
          ${innerA}         
        </div>
              `;
	u(unsplashBoxSelector).append(innerHTML);
};

export const doUnsplashSearch = evt => {
	cleanUpSearchResults();

	const searchPage = evt?.target?.text || 1;
	const inputSearchValue = u('#input-unsplash-search-right').first().value || 'finance report';
	console.log(
		'TCL: doUnsplashSearch evt searchPage, inputSearchValue',
		searchPage,
		inputSearchValue
	);

	return fetch(
		`https://api.unsplash.com/search/photos?query=${inputSearchValue}&per_page=${20}&page=${searchPage}`,
		{
			headers: {
				Authorization: `Client-ID ${process.env.REACT_APP_UNSPLASH_API_KEY}`
			}
		}
	)
		.then(response => response.json())
		.then(data => {
			const images = data.results;
			console.log('TCL: doUnsplashSearch data', images);

			// Add to search results
			images.forEach(imageData => {
				// assetManager.add({
				//   src: imageData.urls.regular,
				//   name: imageData.description || imageData.alt_description
				// });
				const each = `
          <div class="gjs-am-asset gjs-am-asset-image">  
            <div class="gjs-am-preview-cont">        
              <div class="gjs-am-preview" 
                style="background-image: url('${imageData.urls.regular}');">
              </div>
            </div>  
          </div>  
            `;
				u('.gjs-pn-views-container .gjs-am-assets').append(each);
			});
			addEventListenerImageClick();

			// Generate Pagination
			generatePagination(data, searchPage);

			// add click event listener for pagination
			const allElements = u('.unsplash-right-pagination a');
			allElements.handle('click', doUnsplashSearch);

			return images;
		})
		.catch(err => {
			console.error(err);
			// return "";
		});
};

const addUnsplashSearchBoxRightPanel = () => {
	const uUnsplashBox = u(unsplashBoxSelector);
	// console.log('addUnsplashSearchBox -> unsplashBox', uUnsplashBox);
	if (uUnsplashBox.length === 0) {
		const innerHTML = `
                  <div id="${unsplashBox}" class="gjs-am-assets-header">
                    <div class="section-title">Select Image</div>
                    <div class="gjs-am-add-asset">
                        <div class="gjs-field gjs-am-add-field">
                          <input id="${inputSearch}" value="" placeholder="put keyword here">
                        </div>
                        <button id="${submitSearch}" class="gjs-btn-prim">Search</button>
                    </div>
                    <div class="gjs-am-assets" data-el="assets"></div>
                  </div>
                        `;
		checkElement2('.gjs-pn-views-container').then(() => {
			u('.gjs-pn-views-container').append(innerHTML);
			u(submitSearchSelector).handle('click', doUnsplashSearch);
			u(inputSearchSelector).handle('keyup', event => {
				if (event.keyCode === 13) {
					u(submitSearchSelector).trigger('click');
				}
			});
			doUnsplashSearch(null);
		});
	}
};

const addTransparencyTextToColorPicker = () => {
	u('.sp-choose').before('<span>Transparency</span>');
};

export const onInitEditor = (editor, templateName, mode = 'editor') => {
	// console.log('TCL: onInitEditor', editor, templateName);

	// addCSSToTemplate(templateName, mode);
	addTransparencyTextToColorPicker();

	// Absolute mode when in report cover mode
	if (window.GM_BRANDING_TYPE_REPORT_EBOOK && mode === 'editor') {
		// editor.setDragMode('absolute');
		editor.setDragMode('translate');

		u('#grapesjs-react-editor').addClass('reportMode');

		addUnsplashSearchBoxRightPanel();
	}
};
